import { Component, Input, ChangeDetectionStrategy, forwardRef, EventEmitter, Output, ChangeDetectorRef } from '@angular/core'
import { noop } from 'rxjs'
import { CustomField, CustomFieldFromJSON } from 'elements-sdk'
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms'
import { BaseComponent } from 'common/helpers'

@Component({
  selector: 'custom-field-row',
  templateUrl: './customFieldRow.component.pug',
  styleUrls: ['./customFieldRow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFieldRowComponent),
      multi: true,
    },
  ],
})
export class CustomFieldRowComponent extends BaseComponent implements ControlValueAccessor {
  @Input() field: CustomField
  @Input() disabled = false
  @Input() readonly = false
  @Input() required = false
  @Input() indeterminate = false
  @Input() datepickerContainer = false
  @Input() placeholder = ''
  @Input() source?: 'file'|'asset'|'parent'
  @Input() unchanged = false
  @Input() erased = false
  @Input() customContent = false
  @Input() showErase = false
  @Input() showClear = false
  @Input('value') readOnlyValue: any

  @Output() clear = new EventEmitter<void>()
  @Output() erase = new EventEmitter<void>()
  @Output() enter = new EventEmitter<void>()

  innerModel: any
  focus = false
  formControl = new FormControl()

  constructor (
    private cdr: ChangeDetectorRef,
  ) {
    super()
  }

  ngOnInit () {
    if (this.readOnlyValue) {
      this.writeValue(this.readOnlyValue)
    }
  }

  ngAfterViewInit () {
    this.subs.add(
      this.formControl.valueChanges.subscribe(value => {
        this.innerModel = value
        this.onChangeHandler(value)
      }),
    )
  }

  ngOnChanges () {
    if ('number_of_digits' in this.field) {
      this.field = CustomFieldFromJSON(this.field)
    }
  }

  erasable () {
    if (this.indeterminate) {
      return true
    }
    if (this.innerModel?.length === 0) {
      return false
    }
    return ![undefined, null, false, '', []].includes(this.innerModel)
  }

  // ControlValueAccessor
  private onChangeHandler: CallableFunction = noop
  private onTouchHandler: CallableFunction = noop

  writeValue (value: any) {
    if (this.innerModel !== value) {
      this.cdr.markForCheck()
    }
    this.innerModel = value
    this.formControl.setValue(this.innerModel)
  }

  registerOnChange (fn) {
    this.onChangeHandler = fn
  }

  registerOnTouched (fn) {
    this.onTouchHandler = fn
  }

  setDisabledState (disabled) {
    this.disabled = disabled
    this.cdr.markForCheck()
  }

  // eslint-disable-next-line accessor-pairs
  @Input('disabled') set disabledAttribute (value) {
    this.disabled = value
  }
}
